

export const processGeoFieldPoints = (msgArr) => {
  let markerPtsArr = [];

  msgArr.forEach((msg) => {
    const key = Object.keys(msg)[0];
    const fields = msg[key].fields;
    const obj = {};
    const primaryKeys = {};

    fields.forEach((field) => {
      if (!field.hidden) {
        const { title, value, primaryKey, quickView, mandatory } = field;
        if (field.id === "vesselName") {
          obj[field.title] = field.value || "Dummy Vessel Name";
          return;
        }
        if (field.id === "vesselCaptainName") {
          obj[field.title] = field.value || "Dummy Vessel Captain Name";
          return;
        }

        // Collect primaryKey fields
        if (primaryKey || quickView) {
          primaryKeys[title] = value;
        }

        // Add the field value
        obj[field.title] = field.value ?? "";
      }
    });

    obj._primaryKeys = primaryKeys;
    obj._parentKey = key;

    obj._terminalUpdateId = (fields.find(obj => obj.id === "terminalUpdateId") || {}).value;

    markerPtsArr.push(obj);
  });

  return markerPtsArr;
};


export const processGeoFieldValidations = (msgArr) => {
  let markerPtsArr = [];

  msgArr.forEach((msg) => {
    const key = Object.keys(msg)[0];
    const fields = msg[key].fields;
    const obj = {};
    const primaryKeys = {};
    const showInPreviewFields = {};

    fields.forEach((field) => {
      if (!field.hidden) {
        const { title, value, primaryKey, quickView, showInPreview } = field;

        // Collect primaryKey fields
        if (primaryKey || quickView) {
          primaryKeys[title] = value;
        }

        // Collect showInPreview fields
        if (showInPreview) {
          showInPreviewFields[title] = value;
        }

        if (field.title === "Location") {
          obj.iconUrl = field.iconUrl || "";
        }

        obj[field.title] = field.value ?? "";
      }
    });

    // Attach both to the final object
    obj._primaryKeys = primaryKeys;
    obj.showInPreviewFields = showInPreviewFields;
    obj.rowOptions = msg[key].rowOptions
    obj._parentKey = key;

    obj._terminalUpdateId = (fields.find(obj => obj.id === "terminalUpdateId") || {}).value;

    markerPtsArr.push(obj);
  });

  return markerPtsArr;
};
